import React from "react";
import { Link } from "react-router-dom";
import PageLayout, { SectionReveal } from "../components/PageLayout";
import PageHero from "../components/PageHero";
import { ArrowRight, Calendar } from "lucide-react";
import blogPosts from "../data/blogPosts";

const BlogPage = () => {
  const posts = blogPosts;

  const hero = (
    <PageHero
      eyebrow="Blog"
      title="Sesli AI, teknoloji ve işletme üzerine içgörüler"
      subtitle="Verasist ekibinden en güncel yazılar, rehberler ve sektör analizleri."
    />
  );

  return (
    <PageLayout hero={hero}>
      <SectionReveal>
        <section className="py-16 px-6">
          <div className="max-w-4xl mx-auto">
            <div className="grid gap-5">
              {posts.map((post) => (
                <Link
                  key={post.slug}
                  to={`/blog/${post.slug}`}
                  className="rounded-2xl transition-colors duration-200 block overflow-hidden"
                  style={{ background: "var(--card-bg)", border: "1px solid var(--border)" }}
                >
                  {post.image && (
                    <div className="w-full h-48 overflow-hidden">
                      <img
                        src={post.image}
                        alt={post.title}
                        className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                        loading="lazy"
                      />
                    </div>
                  )}
                  <div className="p-6">
                    <div className="flex items-center gap-3 mb-3">
                      <span className="text-[11px] font-medium" style={{ color: "var(--muted)" }}>
                        <Calendar size={12} className="inline mr-1" />{post.date}
                      </span>
                      <span
                        className="text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded-full"
                        style={{ background: "rgba(75,111,212,0.12)", color: "var(--brand-cyan)" }}
                      >
                        {post.tag}
                      </span>
                      <span className="text-[11px]" style={{ color: "var(--muted)" }}>{post.readTime}</span>
                    </div>
                    <h3
                      className="text-[18px] font-semibold mb-2 transition-colors duration-200"
                      style={{ color: "var(--fg)" }}
                    >
                      {post.title}
                    </h3>
                    <p className="text-[14px] leading-relaxed mb-4" style={{ color: "var(--fg)", opacity: 0.82 }}>
                      {post.excerpt}
                    </p>
                    <span
                      className="inline-flex items-center gap-1.5 text-[13px] font-medium transition-colors duration-200"
                      style={{ color: "var(--brand-cyan)" }}
                    >
                      Devamını Oku <ArrowRight size={14} />
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </SectionReveal>
    </PageLayout>
  );
};

export default BlogPage;
